import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertPassouFalhouEnumToBoolean, convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta01Model } from './model-consultaSeguimentoPergunta01'

export const convertConsultaSeguimentoPergunta01ToInput = (
  value: ConsultaSeguimentoPergunta01Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_01_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_01_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_01_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_01_EXEMPLOS?.PASSOU.OLHA_PARA_OBJETO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_01_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_01_EXEMPLOS?.PASSOU.APONTA_PARA_OBJETO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_01_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_01_EXEMPLOS?.PASSOU.OLHA_E_COMENTA_SOBRE_OBJETO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_01_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_01_EXEMPLOS?.PASSOU.OLHA_QUANDO_GENITOR_APONTA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_01_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_01_EXEMPLOS?.FALHOU.IGNORA_VOCE),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_01_07,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_01_EXEMPLOS?.FALHOU.OLHA_AO_REDOR),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_01_08,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_01_EXEMPLOS?.FALHOU.OLHA_PARA_DEDO_DO_GENITOR),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_01_09,
      stResposta: convertPassouFalhouEnumToBoolean(value.PERGUNTA_01_MAIOR_FREQUENCIA),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
